import React from "react";
import { Box } from "@mui/material";
import SidebarMenu from "./CreateNewJobSidebarMenu";

export default function   CreateJobLayout({
  activeIndex,
  setActiveIndex,
  children,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flex: 1,
        overflow: "auto",
        // maxHeight: "100%",
        // height: "62vh",
      }}
    >
      {/* === Left Sidebar (scrolls) === */}
      <Box
        sx={{
          minWidth: "180px",
          maxWidth: "180px",
          // maxHeight: "calc(100vh - 230px)", 
          // height: "100%", // match parent height
          overflowY: "auto", // vertical scroll
          overflowX: "hidden",
          backgroundColor: "var(--gray-0)",
          borderRight: "1px solid var(--gray-200)",

          // Optional scrollbar styling
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--gray-400)",
            borderRadius: "8px",
          },
        }}
      >
        <SidebarMenu
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        />
      </Box>

      {/* === Right Panel (scrolls) === */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: "var(--gray-0)",
          border: "1px solid var(--gray-100)",
          // maxHeight: "calc(90vh - 230px)", 
          minHeight: 0,

          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--gray-400)",
            borderRadius: "8px",
            minHeight: "10px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

